import React from 'react';
import { Notifications as NotificationsEvidence } from '@eas/common-web';

export function Notifications() {
  return <NotificationsEvidence />;
}
